import { TreeNode } from './types';

export const updateNodeInTree = <T extends TreeNode>(
    nodes: T[],
    nodeId: string | number,
    updateFn: (node: T) => Partial<T>
): T[] => {
    return nodes.map((node) => {
        if (node.id === nodeId) {
            return { ...node, ...updateFn(node) };
        }

        if (node.nodes && node.nodes.length > 0) {
            const updatedChildren = updateNodeInTree(node.nodes, nodeId, updateFn);
            if (updatedChildren !== node.nodes) {
                return { ...node, nodes: updatedChildren };
            }
        }

        return node;
    });
};
